import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export const store = new Vuex.Store({
  state: {
    blockOffset: {
      HeaderComponent: 0,
      ElectronicOverhead: 0,
      ElectronicRegistration: 0,
      ElectronicSuccessfullyCompleted: 0,
      FreePeriod: 0,
      ElectronicAdvantages: 0,
      ElectronicRequirement: 0,
      ElectronicEmployees: 0,
      ElectronicTransition: 0,
      ElectronicFAQ: 0,
      FooterComponent: 0,
    },
  },
  getters: {
    getOffsets(state) {
      return state.blockOffset
    },
  },
  mutations: {
    SET_OFFSET(state, offset) {
      state.blockOffset[offset.block] = offset.value
    },
  },
  actions: {
    setOffset({ commit }, offset) {
      commit('SET_OFFSET', offset)
    },
  },
})
